export default "__VITE_ASSET__C6SqrZ_v__"